export function sysbuFnSuggestions(monaco) {
    return [
        {
            label: "globalValues",
            kind: monaco.languages.CompletionItemKind.Variable,
            insertText: "globalValues",
            detail: "Global variable",
        },
        {
            label: "sendRequest",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: `sendRequest({url: '', data: {}})`,
            detail: "API function call",
        },
        {
            label: "setVariable",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'setVariable("path", "value")',
            detail: "set value in global variable",
        },
        {
            label: "setFilter",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'setFilter({\n' +
                '            destination: "listName",\n' +
                '            param: [\n' +
                '                {column: \'column\', operand: \'operand\', value: "value"},\n' +
                '            ]\n' +
                '        })',
            detail: "set filter to list",
        },
        {
            label: "showErrorMessages",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'showErrorMessages(err)',
            detail: "show error messages from backend as notification",
        },
        {
            label: "showMessage",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'showMessage({msgType: \'success\', value: \'Success message\'});',
            detail: "show notification",
        },
        {
            label: "showMessagePopup",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'const response = await showMessage({\n' +
                '            msgType: \'success\',\n' +
                '            value: "Test Message",\n' +
                '            title: "Test Title",\n' +
                '            isPopup: true,\n' +
                '            width: "xs", //available values is: ["xs", "sm", "md", "xl"]\n' +
                '            buttons: {\n' +
                '                "ro": ["Da","Nu"],\n' +
                '                "en": ["Yes","No"]\n' +
                '            }\n' +
                '        })\n' +
                '        //response will return number of clicked button (starts from 1)',
            detail: "show notification",
        },
        {
            label: "setLoading",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'setLoading(true)',
            detail: "set loading state",
        },
        {
            label: "setListData",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'setListData(\'listNameAvailableInScreen\', [])',
            detail: "set list data",
        },
        {
            label: "refreshData",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'refreshData({destination: "listNameAvailableInScreen"})',
            detail: "refresh data in list",
        },
        {
            label: "cancel",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'cancel()',
            detail: "navigation go back or close popup",
        },
        {
            label: "nextScreen",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: 'nextScreen({destination : \'theNextScreenName\', params: {id: \'nextInParamId\'}});',
            detail: "navigation to screen",
        },
    ]
}